export default "__VITE_ASSET__C4XqLH_q__"